var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4477)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.724976 0.5H32.7249V32.5H0.724976V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0124 28.7499V22.8954C20.0124 21.0906 18.536 19.6141 16.7312 19.6141C14.9265 19.6141 13.45 21.0907 13.45 22.8954V28.7499",
    stroke: "#000000",
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1311 24.2008V22.8941C18.1311 22.1243 17.4946 21.4878 16.7249 21.4878",
    stroke: "#000000",
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 30.1563H22.8125V32.0312H10.625V30.1563H16.2499",
    stroke: "#000000",
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8556 20.505L30.8836 17.8181C31.3955 17.6808 31.9263 17.9874 32.0635 18.4992L32.2297 19.1195C32.3668 19.6314 32.0603 20.1622 31.5484 20.2994L21.5035 22.9909M11.9818 25.5422L2.57874 28.0618C2.06699 28.1989 1.53599 27.8925 1.39887 27.3806L1.23268 26.7603C1.09556 26.2485 1.40205 25.7176 1.91387 25.5805L11.8398 22.9208",
    stroke: "#000000",
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67963 24.032L6.55763 19.8448C6.42049 19.333 6.72707 18.8021 7.23881 18.665C7.75062 18.5278 8.28157 18.8344 8.41869 19.3461L9.54062 23.5333L7.67963 24.032ZM23.2425 19.8619L22.1204 15.6748C21.9833 15.163 22.2898 14.632 22.8017 14.4949C23.3135 14.3578 23.8444 14.6643 23.9815 15.1761L25.1034 19.3634L23.2425 19.8619Z",
    stroke: "#000000",
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1249 26.0758V25.1382",
    stroke: "#000000",
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1311 7.25233H14.3149C15.6761 7.25233 16.7899 8.36609 16.7899 9.72734C16.7899 11.0886 15.676 12.2023 14.3149 12.2023H3.67496C2.31382 12.2023 1.19995 11.0886 1.19995 9.72734C1.19995 8.36609 2.31363 7.25233 3.67496 7.25233C3.67496 6.4476 3.94477 5.7059 4.39877 5.11259M10.7249 8.65859V7.25233C10.7249 5.30553 9.1467 3.72734 7.19995 3.72734C6.39513 3.72734 5.65352 3.99721 5.06014 4.45121",
    stroke: "#000000",
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.975 9.72734H14.9125",
    stroke: "#000000",
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8999 7.25233H8.83741",
    stroke: "#000000",
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1124 3.3125C28.6657 3.3125 29.9249 4.57168 29.9249 6.125C29.9249 7.67832 28.6657 8.93751 27.1124 8.93751C25.5591 8.93751 24.2999 7.67832 24.2999 6.125C24.2999 4.57168 25.5591 3.3125 27.1124 3.3125Z",
    stroke: "#000000",
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7535 8.23437L31.9713 8.9375M31.3187 6.12499H32.7249M24.9905 9.77856L24.2875 10.9964M27.0999 10.3437V11.75M29.2094 9.77856L29.9124 10.9964M23.4465 8.23437L22.2286 8.9375M22.8812 6.12499H21.475M23.4465 4.01563L22.2286 3.3125M24.9905 2.47144L24.2875 1.25363M27.0999 1.90625V0.5M29.2094 2.47144L29.9124 1.25363M30.7535 4.01563L31.9713 3.3125",
    stroke: "#000000",
    strokeMiterlimit: 22.926
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 32,
    fill: "white",
    transform: "translate(0.199951 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayground);
export default __webpack_public_path__ + "static/media/playground.454fd9de062597c35a2a077da8a6aa46.svg";
export { ForwardRef as ReactComponent };